export var TOPICS = {
  SHOW_BANNER: 'SHOW_BANNER',
  REMOVE_BANNER: 'REMOVE_BANNER'
};